import staging from './staging';
import production from './production';
import development from './development';

const env = process.env.TARGET_ENV as 'staging' | 'development' | 'production';
export default {
  staging,
  development,
  production,
}[env];
